import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
import store from '@/store'
import ElementUI from 'element-ui';
//element-ui的语言包
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import zhTwLocale from 'element-ui/lib/locale/lang/zh-TW'
import esesLocale from 'element-ui/lib/locale/lang/es'


Vue.use(VueI18n)

const messages = {

    'zh-cn': Object.assign(require('@/languages/zh-CN.json'), zhLocale),
    'en-us': Object.assign(require('@/languages/en-us.json'), enLocale),
    'zh-TW': Object.assign(require('@/languages/zh-TW.json'), zhTwLocale),
    'es-es': Object.assign(require('@/languages/es-es.json'), esesLocale),

}

export function getLanguage() {
    return store.getters.locale;
    const chooseLanguage = Cookies.get('language')
    if (chooseLanguage) return chooseLanguage

    // if has not choose language
    const language = (navigator.language || navigator.browserLanguage).toLowerCase()
   
    const locales = Object.keys(messages)
    for (const locale of locales) {
        if (language.indexOf(locale) > -1) {
            return locale
        }
    }
    return 'en'
}


Vue.use(ElementUI, {
    i18n: (key, value) => i18n.t(key, value)
})


//默认语言包
const i18n = new VueI18n({
    locale: getLanguage(),
    messages
})


export default i18n
